import { connectLocation } from '../../location/LocationConnectors';

const FilterList = connectLocation(
  ({
    t,
    filters,
    filterCounts,
    appliedFilters,
    updateParams,
    resetFilter,
    loading,
    disabled = false,
    showSecondTier = false,
  }) => (
    <>
      {Object.keys(filters)
        .filter(key => !!filters[key].secondTier === showSecondTier)
        .map((filter, index) => {
          const FilterComponent = filters[filter].component;
          const filterProps = filters[filter].props;

          return (
            <FilterComponent
              filterCounts={filterCounts[filter]}
              collapseText={filters[filter].collapseText || t('filter_list.collapse_text')}
              defaultValue={appliedFilters[filter]}
              displayLimit={filters[filter].displayLimit}
              expandText={filters[filter].expandText || t('filter_list.expand_text')}
              filterAttribute={filter}
              // eslint-disable-next-line react/no-array-index-key
              key={`${index}-${filterProps?.startCollapsed}`}
              loading={loading}
              disabled={disabled}
              name={filter}
              onChange={updateParams}
              options={filters[filter].options || []}
              resetFilter={resetFilter}
              title={filters[filter].displayName}
              value={appliedFilters[filter]}
              onComponentChange={filters[filter]?.onComponentChange}
              allFilters={filters}
              allFilterCounts={filterCounts}
              allAppliedFilters={appliedFilters}
              secondTier={filters[filter].secondTier}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...filterProps}
            />
          );
        })}
    </>
  )
);

export default FilterList;
